export class MaplibreZoomEvent {
    #rawEvent;
    constructor(rawEvent) {
        this.#rawEvent = rawEvent;
    }
    get type() {
        switch (this.#rawEvent.type) {
            case 'zoomstart':
                return 'zoomstart';
            case 'zoomend':
                return 'zoomend';
            default:
                throw new Error('maplibre zoom event not handled');
        }
    }
    preventDefault() { }
    get zoom() {
        return this.#rawEvent.target.getZoom();
    }
    static convert(callback) {
        return (e) => callback(new MaplibreZoomEvent(e));
    }
    static isType(eventType) {
        return eventType === 'zoomstart' || eventType === 'zoomend';
    }
    static convertType(eventType) {
        return eventType;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiem9vbS5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJldmVudHMvem9vbS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLE9BQU8saUJBQWlCO0lBQzdCLFNBQVMsQ0FBVTtJQUVuQixZQUFZLFFBQWtCO1FBQzdCLElBQUksQ0FBQyxTQUFTLEdBQUcsUUFBUSxDQUFBO0lBQzFCLENBQUM7SUFFRCxJQUFJLElBQUk7UUFDUCxRQUFRLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDN0IsS0FBSyxXQUFXO2dCQUNmLE9BQU8sV0FBVyxDQUFBO1lBQ25CLEtBQUssU0FBUztnQkFDYixPQUFPLFNBQVMsQ0FBQTtZQUNqQjtnQkFDQyxNQUFNLElBQUksS0FBSyxDQUFDLGlDQUFpQyxDQUFDLENBQUE7UUFDcEQsQ0FBQztJQUNGLENBQUM7SUFFRCxjQUFjLEtBQVUsQ0FBQztJQUV6QixJQUFJLElBQUk7UUFDUCxPQUFPLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLE9BQU8sRUFBRSxDQUFBO0lBQ3ZDLENBQUM7SUFFRCxNQUFNLENBQUMsT0FBTyxDQUNiLFFBQXdDO1FBRXhDLE9BQU8sQ0FBQyxDQUFXLEVBQUUsRUFBRSxDQUFDLFFBQVEsQ0FBQyxJQUFJLGlCQUFpQixDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUE7SUFDM0QsQ0FBQztJQUVELE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBaUI7UUFDOUIsT0FBTyxTQUFTLEtBQUssV0FBVyxJQUFJLFNBQVMsS0FBSyxTQUFTLENBQUE7SUFDNUQsQ0FBQztJQUVELE1BQU0sQ0FBQyxXQUFXLENBQUMsU0FBb0M7UUFDdEQsT0FBTyxTQUFTLENBQUE7SUFDakIsQ0FBQztDQUNEIn0=